import type { PlayerCardData, EntryContext } from './types'
import { sectionOrder } from './sectionOrder'
import { RatingsSection } from './sections/RatingsSection'
import { SummaryStatsSection } from './sections/StatsSection'
import { BioFooter } from './sections/BioFooter'

// The Summary is a cheat-sheet: ratings + the merged stats table (snapshot /
// situational / splits) visible at a glance, bio demoted to a one-line footer.
// Entry context only flips the ratings-vs-stats order.
export function Summary({ player, entry }: { player: PlayerCardData; entry: EntryContext }) {
  return (
    <div>
      {sectionOrder(entry).map((key) =>
        key === 'ratings'
          ? <RatingsSection key="ratings" player={player} />
          : <SummaryStatsSection key="stats" player={player} />,
      )}
      <BioFooter player={player} />
    </div>
  )
}
